import {
    get_contenutiSicurezza,
    get_contenutoSicurezza,
    create_contenutoSicurezza,
    update_contenutoSicurezza,
    sostituisci_contenutoSicurezza,
    duplica_contenutoSicurezza,
    elimina_contenutoSicurezza,
    get_storico_contenutoSicurezza,
} from "@/api/api.contenutosicurezza.js";

const contenutiSicurezza = {
    namespaced: true,

    state: {
        lista: [],
        storico: [],
        corrente: null,
    },

    mutations: {
        SET_LISTA: (state, lista) => {
            state.lista = lista;
        },
        SET_STORICO: (state, storico) => {
            state.storico = storico;
        },
        SET_CORRENTE: (state, contenuto) => {
            state.corrente = contenuto;
        },
    },

    actions: {
        carica({ commit }, filtri) {
            return new Promise((resolve, reject) => {
                get_contenutiSicurezza(filtri).then(resp => {
                    commit("SET_LISTA", resp.data);
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        // Usata dal dialog di sostituzione quando apre conoscendo solo l'id (es.
        // dal calendario): stesso pattern di scadenzeMezzo/caricaDettaglio.
        caricaDettaglio({ commit }, id) {
            return new Promise((resolve, reject) => {
                get_contenutoSicurezza(id).then(resp => {
                    commit("SET_CORRENTE", resp.data);
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        salva({ dispatch }, { id, dati, dispositivoSicurezzaId }) {
            const call = id ? update_contenutoSicurezza(id, dati) : create_contenutoSicurezza(dati);
            return new Promise((resolve, reject) => {
                call.then(resp => {
                    dispatch("carica", { dispositivoSicurezzaId });
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        sostituisci({ dispatch }, { id, dati, dispositivoSicurezzaId }) {
            return new Promise((resolve, reject) => {
                sostituisci_contenutoSicurezza(id, dati).then(resp => {
                    dispatch("carica", { dispositivoSicurezzaId });
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        elimina({ dispatch }, { id, dispositivoSicurezzaId }) {
            return new Promise((resolve, reject) => {
                elimina_contenutoSicurezza(id).then(resp => {
                    dispatch("carica", { dispositivoSicurezzaId });
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        duplica({ dispatch }, { id, dispositivoSicurezzaId }) {
            return new Promise((resolve, reject) => {
                duplica_contenutoSicurezza(id).then(resp => {
                    dispatch("carica", { dispositivoSicurezzaId });
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        caricaStorico({ commit }, id) {
            return new Promise((resolve, reject) => {
                get_storico_contenutoSicurezza(id).then(resp => {
                    commit("SET_STORICO", resp.data);
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },
    },

    getters: {
        lista: state => state.lista,
        storico: state => state.storico,
        corrente: state => state.corrente,
    },
};

export default contenutiSicurezza;
